import { render } from "./App.vue?vue&type=template&id=119fee05"
const script = {}

import "./App.vue?vue&type=style&index=0&id=119fee05&lang=scss"

import exportComponent from "D:\\Dev\\Vue\\guesswhat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__